import KmxMoreVerticalFilled from '@kmx/mui-icons/KmxMoreVerticalFilled';
import { useState } from 'react';

import StyledMenu from './StyledMenu';
import StyledMenuButton from './StyledMenuButton';

type ThreeDotsMenuProps = {
  menuOptions: React.ReactNode;
};

const ThreeDotsMenu = ({ menuOptions }: ThreeDotsMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <StyledMenuButton
        onClick={handleClick}
        size="large"
        className="kmx-car-tile__menu-button"
      >
        <KmxMoreVerticalFilled />
      </StyledMenuButton>

      <StyledMenu
        className="kmx-car-tile__menu"
        data-interactive="true"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
        tabIndex={0}
        slotProps={{
          list: {
            onClick: () => handleClose(),
          },
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {menuOptions}
      </StyledMenu>
    </>
  );
};

export default ThreeDotsMenu;
